import React from 'react';
import styles from './Projects.module.css';

/** Sticky filter bar. `filters` is [{id,label,count}]; id null === "All". */
export default function FilterBar({ filters, active, onChange }) {
  return (
    <div className={styles.filterBar}>
      <div className={styles.filterInner} role="tablist" aria-label="Filter projects">
        {filters.map((f) => (
          <button
            key={f.id ?? 'all'}
            type="button"
            role="tab"
            aria-selected={active === f.id}
            className={styles.filter}
            data-active={active === f.id}
            onClick={() => onChange(f.id)}
          >
            {f.label}
            <span className={styles.count}>{f.count}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
